export const IMPORTANT_INFORMATION = "Важлива інформація до прийому";
export const IMPORTANT_INFORMATION_TEXT =
  "Консультації очно, онлайн, виписка рецептів по доступним лікам, направлення до вузьких спеціалістів, електронні рецепти на антибіотики при призначенні лікарем, електронні лікарняні при захворюваннях, які призводять до непрацездатності. Безоплатний прийом на період воєнного стану для ВПО, при заключеній декларації. Вартість прийому без декларації 400грн.";
export const CONCLUSION_DECLARATION = "Важлива інформація до прийому";
export const CONCLUSION_DECLARATION_TEXT =
  "Ми заключаєм декларації онлайн та очно. Напишіть нам у Viber або Telegram, щоб заключити декларацію.";
export const COMPETENCE = "Компетенція";
export const DOCTORS_RATING = "Рейтинг лікаря";
export const REVIEWS = "Відгуків";
